import { unset } from 'lodash/fp';
import { setOnSuccess } from 'lp-redux-api';
import { selectorForSlice, setState, unsetState } from 'lp-redux-utils';
import { compose } from 'redux';
import { handleActions } from 'redux-actions';
import * as apiActions from 'api-actions';
import * as actions from './actions';
const reducerKey = 'applicants';
const slice = 'root.creditPortal.applicants';
const initialState = {};
const reducer = handleActions({
    [actions.clearApplicationEnvironment.toString()]: unsetState('applicationEnvironment'),
    [actions.clearApplicant.toString()]: (state) => {
        return compose(unset('creditApplication'), unset('personalInfo'), unset('practice'), unset('prequalifications'))(state);
    },
    [actions.setApplicationEnvironment.toString()]: setState('applicationEnvironment'),
    [apiActions.createCreditApplicationIdentityVerification]: setOnSuccess('identityVerification'),
    [actions.setCreditApplication.toString()]: setState('creditApplication'),
    [actions.setPersonalInfo.toString()]: setState('personalInfo'),
    [actions.setPractice.toString()]: setState('practice'),
}, initialState);
const select = selectorForSlice(slice);
const selectors = {
    applicationEnvironment: select('applicationEnvironment'),
    creditApplication: select('creditApplication'),
    personalInfo: select('personalInfo'),
    practice: select('practice'),
    prequalifications: select('prequalifications'),
    identityVerification: select('identityVerification'),
};
export { reducer, selectors, reducerKey };
